//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as axios from "@/store/http";
import treetag from "@/pccomponents/TreeTag";
export default {
  name:'SelectDeptInfo',
  components: {
    treetag
  },
  props:{

   //部门选择框是否是多选
    isMultiple:{
      type: Boolean,
      default: true
    },
    //当前行项的index
    rowindex:{
      type: Number,
      default: -1
    },
    //回调函数
    callbackFun:{
      type:Function,
      default:null
    },
    //清空回调函数
    callclearFun:{
      type:Function,
      default :null
    },
    //已选择部门
    selectdeptid:{
      type:String,
      default:null
    },
    //弹出框所需数据
    bindData:{
      type:Object,
      default: () => ({})
    },
    //编辑项
    editItem:{
      type:String,
      default:''
    },
    //匹配的编辑项
    matchItem:{
      type:String,
      default:''
    },
    // 清空的图标
    clearIcon: {
        type: String,
        default: "el-icon-close"
    },
    // 打开选择的图标
    openIcon: {
        type: String,
        default: "el-icon-files"
    },
    //左侧的树
    treeCode:{
      type:String,
      default:"DEPTTREE"
    }
  },
  data() {
    return {
      //控制弹出框的显示
      dialogVisible: false,
      
      //存储左侧的树列表数据
      deptList: [],
      
      //存储右侧的已选信息
      selectdeptList:[],
      
      //定义树显示的格式
      defaultProps: {
          children: 'children',
          label: 'deptname'
        },
    }
  },
  methods: {
    /**
     * 初始化树结构
     */
    initTree(){
      let url = "deptController/initTree";
      let params = {

      };
      axios.post(url, params).then(({ data }) => {
          this.deptList = data.data.deptList;
      });
    },
    
    /**
     * 打开部门选择框
     */
    openSelectData(){
      //根据树的类型获取查询出当前选中的部门信息   
      this.dialogVisible=true;
    },

    /**
     * 双击选择树形框
     */
    clickDeptTree(row){
      const obj = {};
      //复制选中行的全部信息到最右侧
      for(let key in row){
        obj[key] = row[key];
      }
      //允许用户多选
      if(this.isMultiple){
        //判断当前点击账号和部门是否已经存在选中的列表中，不存在的话则进行添加
        let flag = false;
        let currentDeptid = row["id"];
        for(let i = 0 ; i < this.selectdeptList.length;i++){
           let selectRow = this.selectdeptList[i];
           let selectDeptId = selectRow["id"];
           if(currentDeptid === selectDeptId){
              flag = true;
              break;
           }
        }
        //未选中当前用户，则进行添加
        if(!flag){
          this.selectdeptList.push(obj);
        }

      }else{
        //单选的话，则直接替换数组
        this.selectdeptList.length=0
        this.selectdeptList.push(obj)
      }
    },

    /**
     * 回写选择的部门信息
     */
    confirmDeptInfo(){
      //显示部门名称
      let deptname = "";
      //部门ID
      let deptid = "";
      //已选择了部门列表
      if(this.selectdeptList && this.selectdeptList.length > 0){
        for(let deptInfo of this.selectdeptList){
          if(deptname === ''){
             deptname = deptInfo['deptname'];
          }else{
             deptname = deptname+";"+deptInfo['deptname'];

          }
          if(deptid===''){
            deptid = deptInfo['deptid'];
          }else{
            deptid = deptid +";"+deptInfo['deptid'];
          }
        }
        this.$emit('update:deptid', deptid);
        this.$emit('update:deptname',deptname);
        //回调函数自己调用方法
        if(this.callbackFun != null){
          let params = {
              rowindex : this.rowindex,
              returnData : this.selectdeptList
           }
           this.callbackFun(params);
        }
        this.dialogVisible = false;
      }else{
        //提示请选择人员信息
        this.tipWarn("请选择部门信息");
      }
    },
  
    /**
     * 点击清空
     */
    clearSelectData(){
      //清空数据
      this.$emit('update:deptid', "");
      this.$emit('update:deptname',"");
      //行项的清空，在父组件中自行清除
      if(this.callbackFun != null){
          let params = {
              rowindex : this.rowindex
           }
           this.callclearFun(params);
      }
    },
    
    /**
     * 点击取消按钮，关闭弹出框
     */
    cancelSelect() {
      this.dialogVisible = false;
      this.deptList = [];
      this.selectdeptList = [];
    },

    /**
     * 删除已选
     */
    delDblclick(row) {
      for (let i = 0; i < this.selectdeptList.length; i++) {
        let deptid = this.selectdeptList[i].deptid;
        if (deptid === row.deptid) {
          this.selectdeptList.splice(i, 1);
        }
      }
    },
  },
   computed: {
    readonly: function () {
      if(this.editItem.indexOf(';'+this.matchItem+';')===-1){
        //返回true,设为只读
        return false;
      }else{
        return true;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pccomponents/SelectDeptInfo.vue